module.exports = __webpack_public_path__ + "static/whyJoinImage2-3470169de338e1ffc241cc9dacd1b59b.png";